import { MissingTranslationHandler } from '@ngx-translate/core';

/** Une clé de traduction absente donne un texte vide (comportement historique de l'application) */
export class TraductionAbsenteHandler implements MissingTranslationHandler {
    handle(): string {
        return '';
    }
}
